import React from 'react';
import './NotFound.scss';

function NotFound() {
  return (
    <div className="not-found">
      <h1>404</h1>
      <h2>Página não encontrada</h2>
      <p>A página que você procura não existe ou foi movida.</p>
      <a href="/">Voltar para a página inicial</a>
    </div>
  );
}

export default NotFound;
